import NotificationPage from "components/global/NotificationPage/NotificationPage";

const LenderNotifications = () => <NotificationPage />;

export default LenderNotifications;
